// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/morgans.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.morgans.v1.BackfillAgencyGraphRequest
 */ export class BackfillAgencyGraphRequest extends Message {
    static fromBinary(bytes, options) {
        return new BackfillAgencyGraphRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillAgencyGraphRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillAgencyGraphRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillAgencyGraphRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * awarding toptier agency to backfill
   *
   * @generated from field: string agency_name = 2;
   */ _define_property(this, "agencyName", ""), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 3;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 4;
   */ _define_property(this, "endDate", ""), /**
   * cap per source
   *
   * @generated from field: int32 max_records = 5;
   */ _define_property(this, "maxRecords", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillAgencyGraphRequest, "runtime", proto3);
_define_property(BackfillAgencyGraphRequest, "typeName", "mono.morgans.v1.BackfillAgencyGraphRequest");
_define_property(BackfillAgencyGraphRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillAgencyGraphResponse
 */ export class BackfillAgencyGraphResponse extends Message {
    static fromBinary(bytes, options) {
        return new BackfillAgencyGraphResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillAgencyGraphResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillAgencyGraphResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillAgencyGraphResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 vehicles_fetched = 2;
   */ _define_property(this, "vehiclesFetched", 0), /**
   * @generated from field: int32 nodes_created = 3;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 4;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 5;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 6;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 7;
   */ _define_property(this, "companiesReconciled", 0), /**
   * @generated from field: int32 vehicles_reconciled = 8;
   */ _define_property(this, "vehiclesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillAgencyGraphResponse, "runtime", proto3);
_define_property(BackfillAgencyGraphResponse, "typeName", "mono.morgans.v1.BackfillAgencyGraphResponse");
_define_property(BackfillAgencyGraphResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "vehicles_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "vehicles_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingVehiclesRequest
 */ export class IngestUsaspendingVehiclesRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingVehiclesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingVehiclesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingVehiclesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingVehiclesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * optional: limit to one awarding toptier agency
   *
   * @generated from field: string agency_name = 2;
   */ _define_property(this, "agencyName", ""), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 3;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 4;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 max_records = 5;
   */ _define_property(this, "maxRecords", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingVehiclesRequest, "runtime", proto3);
_define_property(IngestUsaspendingVehiclesRequest, "typeName", "mono.morgans.v1.IngestUsaspendingVehiclesRequest");
_define_property(IngestUsaspendingVehiclesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingVehiclesResponse
 */ export class IngestUsaspendingVehiclesResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingVehiclesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingVehiclesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingVehiclesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingVehiclesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 vehicles_fetched = 1;
   */ _define_property(this, "vehiclesFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0), /**
   * @generated from field: int32 vehicles_reconciled = 7;
   */ _define_property(this, "vehiclesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingVehiclesResponse, "runtime", proto3);
_define_property(IngestUsaspendingVehiclesResponse, "typeName", "mono.morgans.v1.IngestUsaspendingVehiclesResponse");
_define_property(IngestUsaspendingVehiclesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicles_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "vehicles_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestSamOpportunitiesRequest
 */ export class IngestSamOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestSamOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestSamOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestSamOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestSamOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string posted_from = 2;
   */ _define_property(this, "postedFrom", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string posted_to = 3;
   */ _define_property(this, "postedTo", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestSamOpportunitiesRequest, "runtime", proto3);
_define_property(IngestSamOpportunitiesRequest, "typeName", "mono.morgans.v1.IngestSamOpportunitiesRequest");
_define_property(IngestSamOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "posted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "posted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestSamOpportunitiesResponse
 */ export class IngestSamOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestSamOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestSamOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestSamOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestSamOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestSamOpportunitiesResponse, "runtime", proto3);
_define_property(IngestSamOpportunitiesResponse, "typeName", "mono.morgans.v1.IngestSamOpportunitiesResponse");
_define_property(IngestSamOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingAwardsRequest
 */ export class IngestUsaspendingAwardsRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingAwardsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingAwardsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingAwardsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingAwardsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Filters mapped onto the USAspending award search; all optional.
   *
   * company name/UEI substrings
   *
   * @generated from field: repeated string recipient_search_text = 2;
   */ _define_property(this, "recipientSearchText", []), /**
   * awarding toptier agency
   *
   * @generated from field: string agency_name = 3;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: repeated string naics_codes = 4;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string psc_codes = 5;
   */ _define_property(this, "pscCodes", []), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 6;
   */ _define_property(this, "startDate", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string end_date = 7;
   */ _define_property(this, "endDate", ""), /**
   * cap on awards pulled (server clamps)
   *
   * @generated from field: int32 max_records = 8;
   */ _define_property(this, "maxRecords", 0), /**
   * Caller-supplied award records. When non-empty the external USAspending
   * fetch is skipped and these are normalized + ingested directly — lets a
   * caller push curated/cached records (and gives integration tests a
   * deterministic, network-free path through the connector).
   *
   * @generated from field: repeated mono.morgans.v1.FixtureAward fixture_awards = 9;
   */ _define_property(this, "fixtureAwards", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingAwardsRequest, "runtime", proto3);
_define_property(IngestUsaspendingAwardsRequest, "typeName", "mono.morgans.v1.IngestUsaspendingAwardsRequest");
_define_property(IngestUsaspendingAwardsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_search_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "psc_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "fixture_awards",
            kind: "message",
            T: FixtureAward,
            repeated: true
        }
    ]));
/**
 * FixtureAward is the minimal award shape the normalizer reads (recipient +
 * awarding agency chain). Used by IngestUsaspendingAwardsRequest.fixture_awards.
 *
 * @generated from message mono.morgans.v1.FixtureAward
 */ export class FixtureAward extends Message {
    static fromBinary(bytes, options) {
        return new FixtureAward().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixtureAward().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixtureAward().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixtureAward, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_name = 1;
   */ _define_property(this, "recipientName", ""), /**
   * @generated from field: string recipient_uei = 2;
   */ _define_property(this, "recipientUei", ""), /**
   * toptier agency
   *
   * @generated from field: string awarding_agency = 3;
   */ _define_property(this, "awardingAgency", ""), /**
   * optional sub-agency / bureau
   *
   * @generated from field: string awarding_sub_agency = 4;
   */ _define_property(this, "awardingSubAgency", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixtureAward, "runtime", proto3);
_define_property(FixtureAward, "typeName", "mono.morgans.v1.FixtureAward");
_define_property(FixtureAward, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "awarding_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "awarding_sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingAwardsResponse
 */ export class IngestUsaspendingAwardsResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingAwardsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingAwardsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingAwardsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingAwardsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingAwardsResponse, "runtime", proto3);
_define_property(IngestUsaspendingAwardsResponse, "typeName", "mono.morgans.v1.IngestUsaspendingAwardsResponse");
_define_property(IngestUsaspendingAwardsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerScrapeRequest
 */ export class TriggerScrapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new TriggerScrapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerScrapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerScrapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerScrapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string posted_from = 1;
   */ _define_property(this, "postedFrom", ""), /**
   * @generated from field: string posted_to = 2;
   */ _define_property(this, "postedTo", ""), /**
   * @generated from field: int32 max_records = 3;
   */ _define_property(this, "maxRecords", 0), /**
   * @generated from field: bool skip_embedding = 4;
   */ _define_property(this, "skipEmbedding", false), /**
   * @generated from field: bool skip_summaries = 5;
   */ _define_property(this, "skipSummaries", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerScrapeRequest, "runtime", proto3);
_define_property(TriggerScrapeRequest, "typeName", "mono.morgans.v1.TriggerScrapeRequest");
_define_property(TriggerScrapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "posted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "posted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skip_embedding",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "skip_summaries",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerScrapeResponse
 */ export class TriggerScrapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new TriggerScrapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerScrapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerScrapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerScrapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerScrapeResponse, "runtime", proto3);
_define_property(TriggerScrapeResponse, "typeName", "mono.morgans.v1.TriggerScrapeResponse");
_define_property(TriggerScrapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetScrapeStatusRequest
 */ export class GetScrapeStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetScrapeStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetScrapeStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetScrapeStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetScrapeStatusRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetScrapeStatusRequest, "runtime", proto3);
_define_property(GetScrapeStatusRequest, "typeName", "mono.morgans.v1.GetScrapeStatusRequest");
_define_property(GetScrapeStatusRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.GetScrapeStatusResponse
 */ export class GetScrapeStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetScrapeStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetScrapeStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetScrapeStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetScrapeStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string job_id = 2;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: google.protobuf.Timestamp started_at = 3;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 4;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: mono.morgans.v1.ScrapeStats stats = 5;
   */ _define_property(this, "stats", void 0), /**
   * @generated from field: string error_message = 6;
   */ _define_property(this, "errorMessage", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetScrapeStatusResponse, "runtime", proto3);
_define_property(GetScrapeStatusResponse, "typeName", "mono.morgans.v1.GetScrapeStatusResponse");
_define_property(GetScrapeStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "stats",
            kind: "message",
            T: ScrapeStats
        },
        {
            no: 6,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ScrapeStats
 */ export class ScrapeStats extends Message {
    static fromBinary(bytes, options) {
        return new ScrapeStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScrapeStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScrapeStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScrapeStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_fetched = 1;
   */ _define_property(this, "totalFetched", 0), /**
   * @generated from field: int32 created = 2;
   */ _define_property(this, "created", 0), /**
   * @generated from field: int32 updated = 3;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 skipped = 4;
   */ _define_property(this, "skipped", 0), /**
   * @generated from field: int32 embedded = 5;
   */ _define_property(this, "embedded", 0), /**
   * @generated from field: int32 summaries_generated = 6;
   */ _define_property(this, "summariesGenerated", 0), /**
   * @generated from field: int32 errors = 7;
   */ _define_property(this, "errors", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScrapeStats, "runtime", proto3);
_define_property(ScrapeStats, "typeName", "mono.morgans.v1.ScrapeStats");
_define_property(ScrapeStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "embedded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "summaries_generated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "errors",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunitiesRequest
 */ export class ListOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string search = 3;
   */ _define_property(this, "search", ""), /**
   * @generated from field: string agency = 4;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string set_aside_type = 5;
   */ _define_property(this, "setAsideType", ""), /**
   * @generated from field: string naics_code = 6;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string posted_after = 7;
   */ _define_property(this, "postedAfter", ""), /**
   * @generated from field: string deadline_before = 8;
   */ _define_property(this, "deadlineBefore", ""), /**
   * @generated from field: string sort_by = 9;
   */ _define_property(this, "sortBy", ""), /**
   * @generated from field: string sort_order = 10;
   */ _define_property(this, "sortOrder", ""), /**
   * @generated from field: bool active_only = 11;
   */ _define_property(this, "activeOnly", false), /**
   * User tracking filters (MongoDB-backed)
   *
   * @generated from field: string user_id = 12;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 13;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: bool saved_only = 14;
   */ _define_property(this, "savedOnly", false), /**
   * @generated from field: bool alerted_only = 15;
   */ _define_property(this, "alertedOnly", false), /**
   * Filter by scrape source (e.g., "sam.gov", "grants.gov")
   *
   * @generated from field: string source = 16;
   */ _define_property(this, "source", ""), /**
   * Lower bound on response_deadline (RFC3339). Set alongside deadline_before
   * to form a window — e.g. the "Due in N days" chips pass now() here so
   * already-expired postings are excluded from the deadline-filtered results.
   *
   * @generated from field: string deadline_after = 17;
   */ _define_property(this, "deadlineAfter", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesRequest, "runtime", proto3);
_define_property(ListOpportunitiesRequest, "typeName", "mono.morgans.v1.ListOpportunitiesRequest");
_define_property(ListOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_aside_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "posted_after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "deadline_before",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sort_order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "active_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "saved_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "alerted_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "deadline_after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunitiesResponse
 */ export class ListOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.Opportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 4;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: bool has_more = 5;
   */ _define_property(this, "hasMore", false), /**
   * Computed: ceil(total / limit) for frontend pagination
   *
   * @generated from field: int32 total_pages = 6;
   */ _define_property(this, "totalPages", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesResponse, "runtime", proto3);
_define_property(ListOpportunitiesResponse, "typeName", "mono.morgans.v1.ListOpportunitiesResponse");
_define_property(ListOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: Opportunity,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityRequest
 */ export class GetOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityRequest, "runtime", proto3);
_define_property(GetOpportunityRequest, "typeName", "mono.morgans.v1.GetOpportunityRequest");
_define_property(GetOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityResponse
 */ export class GetOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityResponse, "runtime", proto3);
_define_property(GetOpportunityResponse, "typeName", "mono.morgans.v1.GetOpportunityResponse");
_define_property(GetOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchOpportunitiesRequest
 */ export class SearchOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: int32 top_k = 2;
   */ _define_property(this, "topK", 0), /**
   * @generated from field: float min_score = 3;
   */ _define_property(this, "minScore", 0), /**
   * @generated from field: mono.morgans.v1.SearchFilter filter = 4;
   */ _define_property(this, "filter", void 0), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchOpportunitiesRequest, "runtime", proto3);
_define_property(SearchOpportunitiesRequest, "typeName", "mono.morgans.v1.SearchOpportunitiesRequest");
_define_property(SearchOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "top_k",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "min_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 4,
            name: "filter",
            kind: "message",
            T: SearchFilter
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchFilter
 */ export class SearchFilter extends Message {
    static fromBinary(bytes, options) {
        return new SearchFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string department = 1;
   */ _define_property(this, "department", ""), /**
   * @generated from field: string naics_code = 2;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string type_of_set_aside = 3;
   */ _define_property(this, "typeOfSetAside", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchFilter, "runtime", proto3);
_define_property(SearchFilter, "typeName", "mono.morgans.v1.SearchFilter");
_define_property(SearchFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type_of_set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchOpportunitiesResponse
 */ export class SearchOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.SearchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string model = 3;
   */ _define_property(this, "model", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchOpportunitiesResponse, "runtime", proto3);
_define_property(SearchOpportunitiesResponse, "typeName", "mono.morgans.v1.SearchOpportunitiesResponse");
_define_property(SearchOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: SearchResult,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchResult
 */ export class SearchResult extends Message {
    static fromBinary(bytes, options) {
        return new SearchResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0), /**
   * @generated from field: float score = 2;
   */ _define_property(this, "score", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchResult, "runtime", proto3);
_define_property(SearchResult, "typeName", "mono.morgans.v1.SearchResult");
_define_property(SearchResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        },
        {
            no: 2,
            name: "score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GenerateSummaryRequest
 */ export class GenerateSummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateSummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool force = 2;
   */ _define_property(this, "force", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateSummaryRequest, "runtime", proto3);
_define_property(GenerateSummaryRequest, "typeName", "mono.morgans.v1.GenerateSummaryRequest");
_define_property(GenerateSummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "force",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GenerateSummaryResponse
 */ export class GenerateSummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateSummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: bool was_regenerated = 3;
   */ _define_property(this, "wasRegenerated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateSummaryResponse, "runtime", proto3);
_define_property(GenerateSummaryResponse, "typeName", "mono.morgans.v1.GenerateSummaryResponse");
_define_property(GenerateSummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "was_regenerated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillSummariesRequest
 */ export class BackfillSummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new BackfillSummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillSummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillSummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillSummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Max opportunities to process (default 100)
   *
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0), /**
   * Regenerate existing summaries (default false)
   *
   * @generated from field: bool force = 2;
   */ _define_property(this, "force", false), /**
   * Max execution time in milliseconds (default 120000)
   *
   * @generated from field: int32 timeout_ms = 3;
   */ _define_property(this, "timeoutMs", 0), /**
   * If non-empty, restrict backfill to these notice IDs (ignoring `limit`).
   *
   * @generated from field: repeated string notice_ids = 4;
   */ _define_property(this, "noticeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillSummariesRequest, "runtime", proto3);
_define_property(BackfillSummariesRequest, "typeName", "mono.morgans.v1.BackfillSummariesRequest");
_define_property(BackfillSummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "force",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "timeout_ms",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "notice_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillSummariesResponse
 */ export class BackfillSummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new BackfillSummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillSummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillSummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillSummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Total opportunities attempted
   *
   * @generated from field: int32 processed = 1;
   */ _define_property(this, "processed", 0), /**
   * Successfully generated summaries
   *
   * @generated from field: int32 succeeded = 2;
   */ _define_property(this, "succeeded", 0), /**
   * Failed to generate summaries
   *
   * @generated from field: int32 failed = 3;
   */ _define_property(this, "failed", 0), /**
   * Already had summaries (when force=false)
   *
   * @generated from field: int32 skipped = 4;
   */ _define_property(this, "skipped", 0), /**
   * NoticeIds that timed out and should be retried
   *
   * @generated from field: repeated string queued_ids = 5;
   */ _define_property(this, "queuedIds", []), /**
   * Total execution time
   *
   * @generated from field: int64 elapsed_ms = 6;
   */ _define_property(this, "elapsedMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillSummariesResponse, "runtime", proto3);
_define_property(BackfillSummariesResponse, "typeName", "mono.morgans.v1.BackfillSummariesResponse");
_define_property(BackfillSummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "succeeded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "queued_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "elapsed_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityHistoryRequest
 */ export class GetOpportunityHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 2;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityHistoryRequest, "runtime", proto3);
_define_property(GetOpportunityHistoryRequest, "typeName", "mono.morgans.v1.GetOpportunityHistoryRequest");
_define_property(GetOpportunityHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityHistoryResponse
 */ export class GetOpportunityHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.OpportunityVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * "solicitationNumber" or "title"
   *
   * @generated from field: string strategy = 3;
   */ _define_property(this, "strategy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityHistoryResponse, "runtime", proto3);
_define_property(GetOpportunityHistoryResponse, "typeName", "mono.morgans.v1.GetOpportunityHistoryResponse");
_define_property(GetOpportunityHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: OpportunityVersion,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.OpportunityVersion
 */ export class OpportunityVersion extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 2;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: int32 amendment_count = 3;
   */ _define_property(this, "amendmentCount", 0), /**
   * @generated from field: google.protobuf.Timestamp modified_date = 4;
   */ _define_property(this, "modifiedDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 5;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: string ui_link = 6;
   */ _define_property(this, "uiLink", ""), /**
   * @generated from field: string parent_opportunity_id = 7;
   */ _define_property(this, "parentOpportunityId", ""), /**
   * @generated from field: int32 current_version = 8;
   */ _define_property(this, "currentVersion", 0), /**
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * From VersionedOpportunity collection
   *
   * @generated from field: string change_description = 10;
   */ _define_property(this, "changeDescription", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityVersion, "runtime", proto3);
_define_property(OpportunityVersion, "typeName", "mono.morgans.v1.OpportunityVersion");
_define_property(OpportunityVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "modified_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "parent_opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSimilarOpportunitiesRequest
 */ export class GetSimilarOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSimilarOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSimilarOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSimilarOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSimilarOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Source opportunity to find similar to
   *
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * Default: 5
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * 0-100, default 0 (Phase 1 only). Controls Phase 2 rollout.
   *
   * @generated from field: int32 ab_test_rollout_percent = 3;
   */ _define_property(this, "abTestRolloutPercent", 0), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSimilarOpportunitiesRequest, "runtime", proto3);
_define_property(GetSimilarOpportunitiesRequest, "typeName", "mono.morgans.v1.GetSimilarOpportunitiesRequest");
_define_property(GetSimilarOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "ab_test_rollout_percent",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSimilarOpportunitiesResponse
 */ export class GetSimilarOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSimilarOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSimilarOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSimilarOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSimilarOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.SimilarOpportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * "phase1" (NAICS filter) or "phase2" (no NAICS filter)
   *
   * @generated from field: string strategy_used = 2;
   */ _define_property(this, "strategyUsed", ""), /**
   * Before limiting
   *
   * @generated from field: int32 total_candidates = 3;
   */ _define_property(this, "totalCandidates", 0), /**
   * Optional A/B test metrics
   *
   * @generated from field: mono.morgans.v1.SimilarityMetrics metrics = 4;
   */ _define_property(this, "metrics", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSimilarOpportunitiesResponse, "runtime", proto3);
_define_property(GetSimilarOpportunitiesResponse, "typeName", "mono.morgans.v1.GetSimilarOpportunitiesResponse");
_define_property(GetSimilarOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: SimilarOpportunity,
            repeated: true
        },
        {
            no: 2,
            name: "strategy_used",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_candidates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "metrics",
            kind: "message",
            T: SimilarityMetrics
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SimilarOpportunity
 */ export class SimilarOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new SimilarOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimilarOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimilarOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimilarOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0), /**
   * Semantic similarity (0.0-1.0) or 0.8 (structured fallback)
   *
   * @generated from field: double score = 2;
   */ _define_property(this, "score", 0), /**
   * Amendment/version history
   *
   * @generated from field: repeated mono.morgans.v1.TimelineEntry timeline = 3;
   */ _define_property(this, "timeline", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SimilarOpportunity, "runtime", proto3);
_define_property(SimilarOpportunity, "typeName", "mono.morgans.v1.SimilarOpportunity");
_define_property(SimilarOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        },
        {
            no: 2,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "timeline",
            kind: "message",
            T: TimelineEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TimelineEntry
 */ export class TimelineEntry extends Message {
    static fromBinary(bytes, options) {
        return new TimelineEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TimelineEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TimelineEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TimelineEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: int32 amendment_count = 2;
   */ _define_property(this, "amendmentCount", 0), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 3;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp modified_date = 4;
   */ _define_property(this, "modifiedDate", void 0), /**
   * @generated from field: string ui_link = 5;
   */ _define_property(this, "uiLink", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TimelineEntry, "runtime", proto3);
_define_property(TimelineEntry, "typeName", "mono.morgans.v1.TimelineEntry");
_define_property(TimelineEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "modified_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SimilarityMetrics
 */ export class SimilarityMetrics extends Message {
    static fromBinary(bytes, options) {
        return new SimilarityMetrics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimilarityMetrics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimilarityMetrics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimilarityMetrics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 result_count = 1;
   */ _define_property(this, "resultCount", 0), /**
   * Unique NAICS / total results
   *
   * @generated from field: double diversity_score = 2;
   */ _define_property(this, "diversityScore", 0), /**
   * @generated from field: double avg_score = 3;
   */ _define_property(this, "avgScore", 0), /**
   * @generated from field: bool has_source_naics_match = 4;
   */ _define_property(this, "hasSourceNaicsMatch", false), /**
   * @generated from field: int64 latency_ms = 5;
   */ _define_property(this, "latencyMs", protoInt64.zero), /**
   * @generated from field: bool used_semantic_search = 6;
   */ _define_property(this, "usedSemanticSearch", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SimilarityMetrics, "runtime", proto3);
_define_property(SimilarityMetrics, "typeName", "mono.morgans.v1.SimilarityMetrics");
_define_property(SimilarityMetrics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "diversity_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "avg_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "has_source_naics_match",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "latency_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "used_semantic_search",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSavedStatusRequest
 */ export class GetSavedStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSavedStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSavedStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSavedStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSavedStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSavedStatusRequest, "runtime", proto3);
_define_property(GetSavedStatusRequest, "typeName", "mono.morgans.v1.GetSavedStatusRequest");
_define_property(GetSavedStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSavedStatusResponse
 */ export class GetSavedStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSavedStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSavedStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSavedStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSavedStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool saved = 1;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 2;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSavedStatusResponse, "runtime", proto3);
_define_property(GetSavedStatusResponse, "typeName", "mono.morgans.v1.GetSavedStatusResponse");
_define_property(GetSavedStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetAlertStatusRequest
 */ export class GetAlertStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAlertStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAlertStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAlertStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAlertStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAlertStatusRequest, "runtime", proto3);
_define_property(GetAlertStatusRequest, "typeName", "mono.morgans.v1.GetAlertStatusRequest");
_define_property(GetAlertStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetAlertStatusResponse
 */ export class GetAlertStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAlertStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAlertStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAlertStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAlertStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAlertStatusResponse, "runtime", proto3);
_define_property(GetAlertStatusResponse, "typeName", "mono.morgans.v1.GetAlertStatusResponse");
_define_property(GetAlertStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetSavedRequest
 */ export class SetSavedRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetSavedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetSavedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetSavedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetSavedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool saved = 4;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetSavedRequest, "runtime", proto3);
_define_property(SetSavedRequest, "typeName", "mono.morgans.v1.SetSavedRequest");
_define_property(SetSavedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetSavedResponse
 */ export class SetSavedResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetSavedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetSavedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetSavedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetSavedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool saved = 1;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 2;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetSavedResponse, "runtime", proto3);
_define_property(SetSavedResponse, "typeName", "mono.morgans.v1.SetSavedResponse");
_define_property(SetSavedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetAlertRequest
 */ export class SetAlertRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetAlertRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetAlertRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetAlertRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetAlertRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string user_email = 2;
   */ _define_property(this, "userEmail", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 4;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool enabled = 5;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetAlertRequest, "runtime", proto3);
_define_property(SetAlertRequest, "typeName", "mono.morgans.v1.SetAlertRequest");
_define_property(SetAlertRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetAlertResponse
 */ export class SetAlertResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetAlertResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetAlertResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetAlertResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetAlertResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false), /**
   * Current count of enabled alerts for user
   *
   * @generated from field: int32 alert_count = 2;
   */ _define_property(this, "alertCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetAlertResponse, "runtime", proto3);
_define_property(SetAlertResponse, "typeName", "mono.morgans.v1.SetAlertResponse");
_define_property(SetAlertResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "alert_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateTrackingProfileRequest
 */ export class CreateTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 5;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 6;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 7;
   */ _define_property(this, "notifications", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTrackingProfileRequest, "runtime", proto3);
_define_property(CreateTrackingProfileRequest, "typeName", "mono.morgans.v1.CreateTrackingProfileRequest");
_define_property(CreateTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 6,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 7,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateTrackingProfileResponse
 */ export class CreateTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTrackingProfileResponse, "runtime", proto3);
_define_property(CreateTrackingProfileResponse, "typeName", "mono.morgans.v1.CreateTrackingProfileResponse");
_define_property(CreateTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateTrackingProfileRequest
 */ export class UpdateTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 4;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 5;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 6;
   */ _define_property(this, "notifications", void 0), /**
   * @generated from field: bool is_active = 7;
   */ _define_property(this, "isActive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTrackingProfileRequest, "runtime", proto3);
_define_property(UpdateTrackingProfileRequest, "typeName", "mono.morgans.v1.UpdateTrackingProfileRequest");
_define_property(UpdateTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 5,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 6,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        },
        {
            no: 7,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateTrackingProfileResponse
 */ export class UpdateTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTrackingProfileResponse, "runtime", proto3);
_define_property(UpdateTrackingProfileResponse, "typeName", "mono.morgans.v1.UpdateTrackingProfileResponse");
_define_property(UpdateTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeleteTrackingProfileRequest
 */ export class DeleteTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTrackingProfileRequest, "runtime", proto3);
_define_property(DeleteTrackingProfileRequest, "typeName", "mono.morgans.v1.DeleteTrackingProfileRequest");
_define_property(DeleteTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeleteTrackingProfileResponse
 */ export class DeleteTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTrackingProfileResponse, "runtime", proto3);
_define_property(DeleteTrackingProfileResponse, "typeName", "mono.morgans.v1.DeleteTrackingProfileResponse");
_define_property(DeleteTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListTrackingProfilesRequest
 */ export class ListTrackingProfilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTrackingProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTrackingProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTrackingProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTrackingProfilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTrackingProfilesRequest, "runtime", proto3);
_define_property(ListTrackingProfilesRequest, "typeName", "mono.morgans.v1.ListTrackingProfilesRequest");
_define_property(ListTrackingProfilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListTrackingProfilesResponse
 */ export class ListTrackingProfilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTrackingProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTrackingProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTrackingProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTrackingProfilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.TrackingProfile profiles = 1;
   */ _define_property(this, "profiles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTrackingProfilesResponse, "runtime", proto3);
_define_property(ListTrackingProfilesResponse, "typeName", "mono.morgans.v1.ListTrackingProfilesResponse");
_define_property(ListTrackingProfilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles",
            kind: "message",
            T: TrackingProfile,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetTrackingProfileRequest
 */ export class GetTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTrackingProfileRequest, "runtime", proto3);
_define_property(GetTrackingProfileRequest, "typeName", "mono.morgans.v1.GetTrackingProfileRequest");
_define_property(GetTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetTrackingProfileResponse
 */ export class GetTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTrackingProfileResponse, "runtime", proto3);
_define_property(GetTrackingProfileResponse, "typeName", "mono.morgans.v1.GetTrackingProfileResponse");
_define_property(GetTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerMatchRequest
 */ export class TriggerMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new TriggerMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerMatchRequest, "runtime", proto3);
_define_property(TriggerMatchRequest, "typeName", "mono.morgans.v1.TriggerMatchRequest");
_define_property(TriggerMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerMatchResponse
 */ export class TriggerMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new TriggerMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 profiles_processed = 1;
   */ _define_property(this, "profilesProcessed", 0), /**
   * @generated from field: int32 total_matches = 2;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 new_matches = 3;
   */ _define_property(this, "newMatches", 0), /**
   * @generated from field: int32 duplicate_matches = 4;
   */ _define_property(this, "duplicateMatches", 0), /**
   * @generated from field: repeated mono.morgans.v1.MatchError errors = 5;
   */ _define_property(this, "errors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerMatchResponse, "runtime", proto3);
_define_property(TriggerMatchResponse, "typeName", "mono.morgans.v1.TriggerMatchResponse");
_define_property(TriggerMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles_processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "new_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "duplicate_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "errors",
            kind: "message",
            T: MatchError,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MatchError
 */ export class MatchError extends Message {
    static fromBinary(bytes, options) {
        return new MatchError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchError, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string error = 2;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchError, "runtime", proto3);
_define_property(MatchError, "typeName", "mono.morgans.v1.MatchError");
_define_property(MatchError, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewMatchesRequest
 */ export class PreviewMatchesRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewMatchesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewMatchesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewMatchesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewMatchesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 5;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 6;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: int32 limit = 7;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewMatchesRequest, "runtime", proto3);
_define_property(PreviewMatchesRequest, "typeName", "mono.morgans.v1.PreviewMatchesRequest");
_define_property(PreviewMatchesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 6,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 7,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewMatchesResponse
 */ export class PreviewMatchesResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewMatchesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewMatchesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewMatchesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewMatchesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.PreviewOpportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewMatchesResponse, "runtime", proto3);
_define_property(PreviewMatchesResponse, "typeName", "mono.morgans.v1.PreviewMatchesResponse");
_define_property(PreviewMatchesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: PreviewOpportunity,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewOpportunity
 */ export class PreviewOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new PreviewOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string department = 4;
   */ _define_property(this, "department", ""), /**
   * @generated from field: float match_score = 5;
   */ _define_property(this, "matchScore", 0), /**
   * @generated from field: repeated string matched_filters = 6;
   */ _define_property(this, "matchedFilters", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewOpportunity, "runtime", proto3);
_define_property(PreviewOpportunity, "typeName", "mono.morgans.v1.PreviewOpportunity");
_define_property(PreviewOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "match_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 6,
            name: "matched_filters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchesRequest
 */ export class GetMatchesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string status_filter = 4;
   */ _define_property(this, "statusFilter", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchesRequest, "runtime", proto3);
_define_property(GetMatchesRequest, "typeName", "mono.morgans.v1.GetMatchesRequest");
_define_property(GetMatchesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "status_filter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchesResponse
 */ export class GetMatchesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.ProfileMatch matches = 1;
   */ _define_property(this, "matches", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: bool has_more = 3;
   */ _define_property(this, "hasMore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchesResponse, "runtime", proto3);
_define_property(GetMatchesResponse, "typeName", "mono.morgans.v1.GetMatchesResponse");
_define_property(GetMatchesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "matches",
            kind: "message",
            T: ProfileMatch,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchStatsRequest
 */ export class GetMatchStatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchStatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchStatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchStatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchStatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchStatsRequest, "runtime", proto3);
_define_property(GetMatchStatsRequest, "typeName", "mono.morgans.v1.GetMatchStatsRequest");
_define_property(GetMatchStatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchStatsResponse
 */ export class GetMatchStatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchStatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchStatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchStatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchStatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_matches = 1;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 new_matches = 2;
   */ _define_property(this, "newMatches", 0), /**
   * @generated from field: int32 viewed_matches = 3;
   */ _define_property(this, "viewedMatches", 0), /**
   * @generated from field: int32 saved_matches = 4;
   */ _define_property(this, "savedMatches", 0), /**
   * @generated from field: int32 dismissed_matches = 5;
   */ _define_property(this, "dismissedMatches", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchStatsResponse, "runtime", proto3);
_define_property(GetMatchStatsResponse, "typeName", "mono.morgans.v1.GetMatchStatsResponse");
_define_property(GetMatchStatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "new_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "viewed_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "saved_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "dismissed_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MarkMatchViewedRequest
 */ export class MarkMatchViewedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkMatchViewedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkMatchViewedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkMatchViewedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkMatchViewedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkMatchViewedRequest, "runtime", proto3);
_define_property(MarkMatchViewedRequest, "typeName", "mono.morgans.v1.MarkMatchViewedRequest");
_define_property(MarkMatchViewedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MarkMatchViewedResponse
 */ export class MarkMatchViewedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkMatchViewedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkMatchViewedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkMatchViewedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkMatchViewedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkMatchViewedResponse, "runtime", proto3);
_define_property(MarkMatchViewedResponse, "typeName", "mono.morgans.v1.MarkMatchViewedResponse");
_define_property(MarkMatchViewedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DismissMatchRequest
 */ export class DismissMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new DismissMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DismissMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DismissMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DismissMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DismissMatchRequest, "runtime", proto3);
_define_property(DismissMatchRequest, "typeName", "mono.morgans.v1.DismissMatchRequest");
_define_property(DismissMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DismissMatchResponse
 */ export class DismissMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new DismissMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DismissMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DismissMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DismissMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DismissMatchResponse, "runtime", proto3);
_define_property(DismissMatchResponse, "typeName", "mono.morgans.v1.DismissMatchResponse");
_define_property(DismissMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SaveMatchRequest
 */ export class SaveMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveMatchRequest, "runtime", proto3);
_define_property(SaveMatchRequest, "typeName", "mono.morgans.v1.SaveMatchRequest");
_define_property(SaveMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SaveMatchResponse
 */ export class SaveMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveMatchResponse, "runtime", proto3);
_define_property(SaveMatchResponse, "typeName", "mono.morgans.v1.SaveMatchResponse");
_define_property(SaveMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetHealthRequest
 */ export class GetHealthRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetHealthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHealthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHealthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetHealthRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetHealthRequest, "runtime", proto3);
_define_property(GetHealthRequest, "typeName", "mono.morgans.v1.GetHealthRequest");
_define_property(GetHealthRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.GetHealthResponse
 */ export class GetHealthResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetHealthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHealthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHealthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetHealthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool healthy = 1;
   */ _define_property(this, "healthy", false), /**
   * @generated from field: string database_status = 2;
   */ _define_property(this, "databaseStatus", ""), /**
   * @generated from field: string qdrant_status = 3;
   */ _define_property(this, "qdrantStatus", ""), /**
   * @generated from field: string scraper_status = 4;
   */ _define_property(this, "scraperStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp last_scrape = 5;
   */ _define_property(this, "lastScrape", void 0), /**
   * @generated from field: int32 opportunity_count = 6;
   */ _define_property(this, "opportunityCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetHealthResponse, "runtime", proto3);
_define_property(GetHealthResponse, "typeName", "mono.morgans.v1.GetHealthResponse");
_define_property(GetHealthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "healthy",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "database_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qdrant_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scraper_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "last_scrape",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "opportunity_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Opportunity
 */ export class Opportunity extends Message {
    static fromBinary(bytes, options) {
        return new Opportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Opportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Opportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Opportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string department = 6;
   */ _define_property(this, "department", ""), /**
   * @generated from field: string sub_tier = 7;
   */ _define_property(this, "subTier", ""), /**
   * @generated from field: string office = 8;
   */ _define_property(this, "office", ""), /**
   * @generated from field: string full_agency_hierarchy = 9;
   */ _define_property(this, "fullAgencyHierarchy", ""), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 10;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: string type = 11;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string base_type = 12;
   */ _define_property(this, "baseType", ""), /**
   * @generated from field: string type_of_set_aside_description = 13;
   */ _define_property(this, "typeOfSetAsideDescription", ""), /**
   * @generated from field: string type_of_set_aside = 14;
   */ _define_property(this, "typeOfSetAside", ""), /**
   * @generated from field: google.protobuf.Timestamp response_deadline = 15;
   */ _define_property(this, "responseDeadline", void 0), /**
   * @generated from field: string naics_code = 16;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: repeated string naics_codes = 17;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: string classification_code = 18;
   */ _define_property(this, "classificationCode", ""), /**
   * @generated from field: bool active = 19;
   */ _define_property(this, "active", false), /**
   * @generated from field: string ui_link = 20;
   */ _define_property(this, "uiLink", ""), /**
   * @generated from field: string additional_info_link = 21;
   */ _define_property(this, "additionalInfoLink", ""), /**
   * @generated from field: repeated mono.morgans.v1.Contact contacts = 22;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: mono.morgans.v1.Address office_address = 23;
   */ _define_property(this, "officeAddress", void 0), /**
   * @generated from field: mono.morgans.v1.Address place_of_performance = 24;
   */ _define_property(this, "placeOfPerformance", void 0), /**
   * @generated from field: mono.morgans.v1.Award award = 25;
   */ _define_property(this, "award", void 0), /**
   * @generated from field: bool has_attachments = 26;
   */ _define_property(this, "hasAttachments", false), /**
   * @generated from field: int32 attachment_count = 27;
   */ _define_property(this, "attachmentCount", 0), /**
   * @generated from field: string summary = 28;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: google.protobuf.Timestamp summary_generated_at = 29;
   */ _define_property(this, "summaryGeneratedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_scraped_at = 30;
   */ _define_property(this, "lastScrapedAt", void 0), /**
   * @generated from field: int32 amendment_count = 31;
   */ _define_property(this, "amendmentCount", 0), /**
   * User tracking (MongoDB-backed, populated when user_id provided)
   *
   * @generated from field: bool is_saved = 32;
   */ _define_property(this, "isSaved", false), /**
   * @generated from field: string saved_notes = 33;
   */ _define_property(this, "savedNotes", ""), /**
   * @generated from field: bool is_alerted = 34;
   */ _define_property(this, "isAlerted", false), /**
   * All versions from MongoDB (list view only)
   *
   * @generated from field: repeated mono.morgans.v1.OpportunityVersion versions = 35;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int32 version_count = 36;
   */ _define_property(this, "versionCount", 0), /**
   * URL to full description on SAM.gov
   *
   * @generated from field: string description_link = 37;
   */ _define_property(this, "descriptionLink", ""), /**
   * Source of the opportunity data (e.g., "sam.gov", "grants.gov")
   *
   * @generated from field: string scrape_source = 38;
   */ _define_property(this, "scrapeSource", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Opportunity, "runtime", proto3);
_define_property(Opportunity, "typeName", "mono.morgans.v1.Opportunity");
_define_property(Opportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sub_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "full_agency_hierarchy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "base_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "type_of_set_aside_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "type_of_set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "response_deadline",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "classification_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "additional_info_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "contacts",
            kind: "message",
            T: Contact,
            repeated: true
        },
        {
            no: 23,
            name: "office_address",
            kind: "message",
            T: Address
        },
        {
            no: 24,
            name: "place_of_performance",
            kind: "message",
            T: Address
        },
        {
            no: 25,
            name: "award",
            kind: "message",
            T: Award
        },
        {
            no: 26,
            name: "has_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 27,
            name: "attachment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 28,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "summary_generated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 30,
            name: "last_scraped_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 32,
            name: "is_saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "saved_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "is_alerted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 35,
            name: "versions",
            kind: "message",
            T: OpportunityVersion,
            repeated: true
        },
        {
            no: 36,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 37,
            name: "description_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "scrape_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Contact
 */ export class Contact extends Message {
    static fromBinary(bytes, options) {
        return new Contact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Contact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Contact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Contact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string full_name = 2;
   */ _define_property(this, "fullName", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 4;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Contact, "runtime", proto3);
_define_property(Contact, "typeName", "mono.morgans.v1.Contact");
_define_property(Contact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Address
 */ export class Address extends Message {
    static fromBinary(bytes, options) {
        return new Address().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Address().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Address().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Address, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string street = 1;
   */ _define_property(this, "street", ""), /**
   * @generated from field: string city = 2;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip = 4;
   */ _define_property(this, "zip", ""), /**
   * @generated from field: string country_code = 5;
   */ _define_property(this, "countryCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Address, "runtime", proto3);
_define_property(Address, "typeName", "mono.morgans.v1.Address");
_define_property(Address, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "street",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "zip",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "country_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Award
 */ export class Award extends Message {
    static fromBinary(bytes, options) {
        return new Award().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Award().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Award().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Award, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string number = 1;
   */ _define_property(this, "number", ""), /**
   * @generated from field: string date = 2;
   */ _define_property(this, "date", ""), /**
   * @generated from field: string amount = 3;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string awardee_name = 4;
   */ _define_property(this, "awardeeName", ""), /**
   * @generated from field: string awardee_uei = 5;
   */ _define_property(this, "awardeeUei", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Award, "runtime", proto3);
_define_property(Award, "typeName", "mono.morgans.v1.Award");
_define_property(Award, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "awardee_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "awardee_uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TrackingProfile
 */ export class TrackingProfile extends Message {
    static fromBinary(bytes, options) {
        return new TrackingProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrackingProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrackingProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrackingProfile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string embedding_status = 6;
   */ _define_property(this, "embeddingStatus", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 7;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 8;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 9;
   */ _define_property(this, "notifications", void 0), /**
   * @generated from field: bool is_active = 10;
   */ _define_property(this, "isActive", false), /**
   * @generated from field: google.protobuf.Timestamp last_matched_at = 11;
   */ _define_property(this, "lastMatchedAt", void 0), /**
   * @generated from field: int32 match_count = 12;
   */ _define_property(this, "matchCount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TrackingProfile, "runtime", proto3);
_define_property(TrackingProfile, "typeName", "mono.morgans.v1.TrackingProfile");
_define_property(TrackingProfile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "embedding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 8,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 9,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        },
        {
            no: 10,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "last_matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "match_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TrackingProfileFilters
 */ export class TrackingProfileFilters extends Message {
    static fromBinary(bytes, options) {
        return new TrackingProfileFilters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrackingProfileFilters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrackingProfileFilters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrackingProfileFilters, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string naics_codes = 1;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string psc_codes = 2;
   */ _define_property(this, "pscCodes", []), /**
   * @generated from field: repeated string set_aside_codes = 3;
   */ _define_property(this, "setAsideCodes", []), /**
   * @generated from field: repeated string agencies = 4;
   */ _define_property(this, "agencies", []), /**
   * @generated from field: repeated string states = 5;
   */ _define_property(this, "states", []), /**
   * @generated from field: double min_value = 6;
   */ _define_property(this, "minValue", 0), /**
   * @generated from field: double max_value = 7;
   */ _define_property(this, "maxValue", 0), /**
   * @generated from field: repeated string keywords = 8;
   */ _define_property(this, "keywords", []), /**
   * @generated from field: repeated string exclude_keywords = 9;
   */ _define_property(this, "excludeKeywords", []), /**
   * @generated from field: repeated string notice_types = 10;
   */ _define_property(this, "noticeTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TrackingProfileFilters, "runtime", proto3);
_define_property(TrackingProfileFilters, "typeName", "mono.morgans.v1.TrackingProfileFilters");
_define_property(TrackingProfileFilters, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "psc_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "set_aside_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "agencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "states",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "min_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "max_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "keywords",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "exclude_keywords",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "notice_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MatchingConfig
 */ export class MatchingConfig extends Message {
    static fromBinary(bytes, options) {
        return new MatchingConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchingConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchingConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchingConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double semantic_threshold = 1;
   */ _define_property(this, "semanticThreshold", 0), /**
   * @generated from field: bool require_all_filters = 2;
   */ _define_property(this, "requireAllFilters", false), /**
   * @generated from field: bool include_expired_opportunities = 3;
   */ _define_property(this, "includeExpiredOpportunities", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchingConfig, "runtime", proto3);
_define_property(MatchingConfig, "typeName", "mono.morgans.v1.MatchingConfig");
_define_property(MatchingConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "semantic_threshold",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "require_all_filters",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "include_expired_opportunities",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.NotificationConfig
 */ export class NotificationConfig extends Message {
    static fromBinary(bytes, options) {
        return new NotificationConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false), /**
   * @generated from field: string frequency = 2;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: repeated string email_addresses = 3;
   */ _define_property(this, "emailAddresses", []), /**
   * @generated from field: bool include_in_digest = 4;
   */ _define_property(this, "includeInDigest", false), /**
   * @generated from field: double min_match_score = 5;
   */ _define_property(this, "minMatchScore", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationConfig, "runtime", proto3);
_define_property(NotificationConfig, "typeName", "mono.morgans.v1.NotificationConfig");
_define_property(NotificationConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email_addresses",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "include_in_digest",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "min_match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ProfileMatch
 */ export class ProfileMatch extends Message {
    static fromBinary(bytes, options) {
        return new ProfileMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProfileMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProfileMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProfileMatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string profile_id = 2;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string opportunity_notice_id = 3;
   */ _define_property(this, "opportunityNoticeId", ""), /**
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * @generated from field: float match_score = 5;
   */ _define_property(this, "matchScore", 0), /**
   * @generated from field: repeated string matched_filters = 6;
   */ _define_property(this, "matchedFilters", []), /**
   * @generated from field: google.protobuf.Timestamp matched_at = 7;
   */ _define_property(this, "matchedAt", void 0), /**
   * @generated from field: bool notification_sent = 8;
   */ _define_property(this, "notificationSent", false), /**
   * @generated from field: bool viewed = 9;
   */ _define_property(this, "viewed", false), /**
   * @generated from field: google.protobuf.Timestamp viewed_at = 10;
   */ _define_property(this, "viewedAt", void 0), /**
   * @generated from field: bool dismissed = 11;
   */ _define_property(this, "dismissed", false), /**
   * @generated from field: bool saved = 12;
   */ _define_property(this, "saved", false), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 13;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProfileMatch, "runtime", proto3);
_define_property(ProfileMatch, "typeName", "mono.morgans.v1.ProfileMatch");
_define_property(ProfileMatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "match_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 6,
            name: "matched_filters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "notification_sent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "viewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "viewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "dismissed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        }
    ]));
